import { Component, inject, OnInit } from '@angular/core';
import { TabViewChangeEvent, TabViewModule } from 'primeng/tabview';
import { SearchComponent } from './search/search.component';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { DashboardService } from '../../../services/dashboard.service';
import { ChargeListComponent } from "./charge-list/charge-list.component";



@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [TabViewModule, SearchComponent, ChargeListComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css',

})
export class DashboardComponent implements OnInit {

  tabindex: number = 1;
  subscriptions: Subscription = new Subscription();
  router = inject(Router);

  dashboardService = inject(DashboardService);

  ngOnInit(): void {
    if (localStorage.getItem("activeTab")) {
      this.tabindex = JSON.parse(localStorage.getItem("activeTab") ?? "");
    }
  }

  handleTavChange(e: TabViewChangeEvent) {
    var index = e.index;
    localStorage.setItem("activeTab", JSON.stringify(index));
  }


}
